function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AdBreakType, AdStreamType, CompanionProvider, SsaiStitcherType, TrackingEventType } from '../../../../../addons/adverts/common';
import { CoreVideoInternal } from '../../../../../core-video-internal';
import { StreamingProtocol } from '../../../../../core/player/playout-data';
import { isSafariDesktop } from '../../../../../utils/device-type';
import { ptTimeToSeconds } from '../../../../../utils/pt-time-conversion';
import { JsonAdBreakTrackingEvent, JsonAdBreakTrackingEventMap } from '../../json-ad-breaks';
import { mapCompanionAds } from '../../media-tailor-companions';
import { DoubleBoxToAdBreaksAdapter } from '../double-box/double-box-to-ad-breaks-adapter';
import { roughlyEquals } from '../../../../../utils/ad-break-utils';
import { filterTxmlContent, findNodeWithTagName, getAttributeFromNode, parseTxmlContent } from '../../../../../utils/txml-utils';
import { sdkLogger } from '../../../../../logger';
import { getAdvertisingContentType } from '../../../../../addons/adverts/advert-content-type';
export var JsonAdBreaksAdapter = /*#__PURE__*/ function() {
    "use strict";
    function JsonAdBreaksAdapter() {
        var _this = this;
        var ssaiStitcherType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SsaiStitcherType.None, adBreakEndAdjustment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, adBreakStartAdjustment = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        _class_call_check(this, JsonAdBreaksAdapter);
        _define_property(this, "ssaiStitcherType", void 0);
        _define_property(this, "adBreakEndAdjustment", void 0);
        _define_property(this, "adBreakStartAdjustment", void 0);
        _define_property(this, "parseAdExtension", void 0);
        _define_property(this, "parseTrackingEvent", void 0);
        _define_property(this, "parseNonLinearAdData", void 0);
        _define_property(this, "parseCompanionAdData", void 0);
        _define_property(this, "parseNonLinearAdBreakData", void 0);
        this.ssaiStitcherType = ssaiStitcherType;
        this.adBreakEndAdjustment = adBreakEndAdjustment;
        this.adBreakStartAdjustment = adBreakStartAdjustment;
        this.parseAdExtension = function(extension) {
            var _filterTxmlContent_;
            var extensionDocument = parseTxmlContent(extension.content);
            var paramNodes = filterTxmlContent(extensionDocument, function(node) {
                return node.tagName.toLowerCase() === 'creativeparameter';
            });
            var _filterTxmlContent__children;
            var programmaticChildren = (_filterTxmlContent__children = (_filterTxmlContent_ = filterTxmlContent(extensionDocument, function(node) {
                return node.tagName.toLowerCase() === 'programmatic';
            })[0]) === null || _filterTxmlContent_ === void 0 ? void 0 : _filterTxmlContent_.children) !== null && _filterTxmlContent__children !== void 0 ? _filterTxmlContent__children : [];
            return {
                type: extension.type,
                parameters: paramNodes.map(function(parameter) {
                    var value = parameter.children.map(function(node) {
                        return typeof node === 'string' ? node : node.children[0];
                    }).join('');
                    return {
                        creativeId: parameter.attributes['creativeId'],
                        type: parameter.attributes['type'],
                        name: parameter.attributes['name'],
                        value: value
                    };
                }),
                programmatic: programmaticChildren.map(function(element) {
                    return {
                        name: element.tagName,
                        value: typeof element === 'string' ? element : element.children[0]
                    };
                })
            };
        };
        this.parseTrackingEvent = function(trackingEvent) {
            return trackingEvent.beaconUrls.map(function(url) {
                return {
                    type: trackingEvent.eventType,
                    url: url
                };
            });
        };
        this.parseNonLinearAdData = function(nonLinearAdList) {
            var _trackingEvents_find;
            if (!nonLinearAdList || !nonLinearAdList.nonLinearAdList || nonLinearAdList.nonLinearAdList.length === 0) {
                return {
                    adStartedBeacons: [],
                    adFinishedBeacons: [],
                    adClickedBeacons: [],
                    variants: []
                };
            }
            var trackingEvents = nonLinearAdList.trackingEvents;
            var freewheelStartBeacons = ((_trackingEvents_find = trackingEvents.find(function(event) {
                return event.eventType === TrackingEventType.AdImpression;
            })) === null || _trackingEvents_find === void 0 ? void 0 : _trackingEvents_find.beaconUrls) || [];
            var nonLinearAd = nonLinearAdList.nonLinearAdList[0];
            return {
                adStartedBeacons: freewheelStartBeacons,
                adFinishedBeacons: [],
                adClickedBeacons: [
                    nonLinearAd.clickTracking
                ],
                variants: [
                    {
                        height: Number(nonLinearAd.height),
                        width: Number(nonLinearAd.width),
                        mimeType: nonLinearAd.staticResourceCreativeType,
                        resourceUri: nonLinearAd.staticResource
                    }
                ]
            };
        };
        this.parseCompanionAdData = function(nonLinearAdList, adStartTimeInSeconds, companionAdTemplateType) {
            var _trackingEvents_find;
            if (!nonLinearAdList || !nonLinearAdList.nonLinearAdList || nonLinearAdList.nonLinearAdList.length === 0) {
                return {
                    adStartedBeacons: [],
                    adFinishedBeacons: [],
                    adClickedBeacons: [],
                    variants: []
                };
            }
            var extensions = nonLinearAdList.extensions, trackingEvents = nonLinearAdList.trackingEvents, _nonLinearAdList_nonLinearAdList = _sliced_to_array(nonLinearAdList.nonLinearAdList, 1), _nonLinearAdList_nonLinearAdList_ = _nonLinearAdList_nonLinearAdList[0], clickTracking = _nonLinearAdList_nonLinearAdList_.clickTracking, adId = _nonLinearAdList_nonLinearAdList_.adId, adSystem = _nonLinearAdList_nonLinearAdList_.adSystem, adTitle = _nonLinearAdList_nonLinearAdList_.adTitle, creativeId = _nonLinearAdList_nonLinearAdList_.creativeId, durationInSeconds = _nonLinearAdList_nonLinearAdList_.durationInSeconds, staticResource = _nonLinearAdList_nonLinearAdList_.staticResource;
            var freewheelStartBeacons = ((_trackingEvents_find = trackingEvents.find(function(event) {
                return event.eventType === TrackingEventType.AdImpression;
            })) === null || _trackingEvents_find === void 0 ? void 0 : _trackingEvents_find.beaconUrls) || [];
            return {
                adStartedBeacons: freewheelStartBeacons,
                adFinishedBeacons: [],
                adClickedBeacons: [
                    clickTracking
                ],
                variants: [
                    {
                        adBreak: {
                            id: adId
                        },
                        adId: adId,
                        adInsights: _this.parseNonLinearAdDataExtensions(extensions[0].content, creativeId),
                        adSystem: adSystem,
                        adTitle: adTitle,
                        creativeId: creativeId,
                        durationInSeconds: durationInSeconds,
                        startTimeInSeconds: adStartTimeInSeconds,
                        staticResource: staticResource,
                        companionAdTemplateType: companionAdTemplateType
                    }
                ]
            };
        };
        this.parseNonLinearAdBreakData = function(nonLinearAdBreak) {
            var _nonLinearAdsList_;
            var startBeacons = nonLinearAdBreak.adBreakTrackingEvents.find(function(event) {
                return event.eventType === JsonAdBreakTrackingEvent.BREAK_START;
            });
            var endBeacons = nonLinearAdBreak.adBreakTrackingEvents.find(function(event) {
                return event.eventType === JsonAdBreakTrackingEvent.BREAK_END;
            });
            var nonLinearAdsList = nonLinearAdBreak.nonLinearAdsList, startTimeInSeconds = nonLinearAdBreak.startTimeInSeconds;
            var nonLinearAdType = _this.determineNonLinearAdType((_nonLinearAdsList_ = nonLinearAdsList[nonLinearAdsList.length - 1]) === null || _nonLinearAdsList_ === void 0 ? void 0 : _nonLinearAdsList_.extensions);
            var ad = nonLinearAdType ? _this.parseCompanionAdData(nonLinearAdsList[nonLinearAdsList.length - 1], startTimeInSeconds, nonLinearAdType) : _this.parseNonLinearAdData(nonLinearAdsList[0]);
            return {
                adStartedBeacons: _to_consumable_array(startBeacons ? startBeacons.beaconUrls : []).concat(_to_consumable_array(ad.adStartedBeacons)),
                adFinishedBeacons: _to_consumable_array(endBeacons ? endBeacons.beaconUrls : []).concat(_to_consumable_array(ad.adFinishedBeacons)),
                adClickedBeacons: ad.adClickedBeacons,
                variants: ad.variants
            };
        };
    }
    _create_class(JsonAdBreaksAdapter, [
        {
            key: "adapt",
            value: function adapt(jsonAdBreaks, isCsai, adServerCdn) {
                var _this = this;
                var avails = jsonAdBreaks.avails;
                var adBreakData = avails.sort(function(a1, a2) {
                    return a1.startTimeInSeconds - a2.startTimeInSeconds;
                }).map(function(adBreak) {
                    return _this.parseAdBreakData(adBreak, isCsai, adServerCdn);
                });
                var _DoubleBoxToAdBreaksAdapter_splitDoubleBoxFromNonLinearAvails = DoubleBoxToAdBreaksAdapter.splitDoubleBoxFromNonLinearAvails(jsonAdBreaks.nonLinearAvails), doubleBoxAds = _DoubleBoxToAdBreaksAdapter_splitDoubleBoxFromNonLinearAvails.doubleBoxAds, nonLinearAds = _DoubleBoxToAdBreaksAdapter_splitDoubleBoxFromNonLinearAvails.nonLinearAds;
                var combinedAdBreaks = adBreakData;
                if (doubleBoxAds.length) {
                    combinedAdBreaks = DoubleBoxToAdBreaksAdapter.adapt(adBreakData, doubleBoxAds, this.parseAdBreakData.bind(this), isCsai, adServerCdn);
                }
                var nonLinearAdData = nonLinearAds.map(this.parseNonLinearAdBreakData);
                return {
                    adBreaks: combinedAdBreaks,
                    nonLinearAds: nonLinearAdData
                };
            }
        },
        {
            key: "parseBaseAdData",
            value: function parseBaseAdData(ad, adBreak) {
                var _this = this;
                var _ad_nonLinearAdList;
                var trackingEvents = [];
                ad.trackingEvents.forEach(function(event) {
                    var _trackingEvents;
                    (_trackingEvents = trackingEvents).push.apply(_trackingEvents, _to_consumable_array(_this.parseTrackingEvent(event)));
                });
                var nonLinearAd = (_ad_nonLinearAdList = ad.nonLinearAdList) === null || _ad_nonLinearAdList === void 0 ? void 0 : _ad_nonLinearAdList[0];
                var baseAdGenericMetadata = nonLinearAd !== null && nonLinearAd !== void 0 ? nonLinearAd : ad;
                var adMetadata = {
                    id: baseAdGenericMetadata.adId,
                    name: baseAdGenericMetadata.adTitle,
                    creativeId: baseAdGenericMetadata.creativeId,
                    adSystem: baseAdGenericMetadata.adSystem,
                    expectedDuration: baseAdGenericMetadata.durationInSeconds
                };
                var baseData = _object_spread({
                    adBreakId: adBreak.id,
                    adBreakType: adBreak.type,
                    extensions: ad.extensions.map(this.parseAdExtension),
                    verifications: this.getAdVerifications(ad),
                    streamingProtocol: this.determineAdStreamProtocol(),
                    trackingEvents: trackingEvents
                }, adMetadata);
                var availAd = ad;
                if (availAd.vastAdId) {
                    baseData.freewheelId = availAd.vastAdId;
                } else if (nonLinearAd) {
                    baseData.freewheelId = nonLinearAd.adId;
                }
                if (availAd.companionAds) {
                    baseData.companions = mapCompanionAds(availAd.companionAds);
                }
                return baseData;
            }
        },
        {
            key: "parseAdData",
            value: function parseAdData(ad, adBreak, adType, adServerCdn) {
                var baseAd = this.parseBaseAdData(ad, adBreak);
                if (adType !== 'VodAd') {
                    return baseAd;
                } else {
                    var _baseAd_trackingEvents;
                    return _object_spread_props(_object_spread({}, baseAd), {
                        cdns: ad.mediaFile ? [
                            {
                                url: ad.mediaFile,
                                name: adServerCdn !== null && adServerCdn !== void 0 ? adServerCdn : 'ad-server'
                            }
                        ] : [],
                        trackingEvents: (_baseAd_trackingEvents = baseAd.trackingEvents) !== null && _baseAd_trackingEvents !== void 0 ? _baseAd_trackingEvents : []
                    });
                }
            }
        },
        {
            key: "getAdBreakTrackingEvents",
            value: function getAdBreakTrackingEvents(rawAdBreak) {
                var _this = this;
                var adBreakTrackingEvents = [];
                if (rawAdBreak.adBreakTrackingEvents) {
                    rawAdBreak.adBreakTrackingEvents.forEach(function(event) {
                        var _adBreakTrackingEvents;
                        var adaptedEvent = _object_spread_props(_object_spread({}, event), {
                            eventType: JsonAdBreakTrackingEventMap[event.eventType]
                        });
                        (_adBreakTrackingEvents = adBreakTrackingEvents).push.apply(_adBreakTrackingEvents, _to_consumable_array(_this.parseTrackingEvent(adaptedEvent)));
                    });
                }
                return adBreakTrackingEvents;
            }
        },
        {
            key: "initialiseAdBreak",
            value: function initialiseAdBreak(rawAdBreak) {
                var adBreakType = rawAdBreak.startTimeInSeconds === 0 ? AdBreakType.Preroll : AdBreakType.Midroll;
                var adBreak = {
                    ads: [],
                    id: rawAdBreak.availId,
                    ssaiStitcherType: this.ssaiStitcherType,
                    trackingEvents: [],
                    streamType: this.ssaiStitcherType === SsaiStitcherType.None ? AdStreamType.Separate : AdStreamType.InStream,
                    type: adBreakType,
                    watched: false
                };
                if (ptTimeToSeconds(rawAdBreak.startTime)) {
                    adBreak.position = ptTimeToSeconds(rawAdBreak.startTime) + this.adBreakStartAdjustment;
                } else if (rawAdBreak.startTimeInSeconds !== undefined && rawAdBreak.startTimeInSeconds !== null) {
                    adBreak.position = rawAdBreak.startTimeInSeconds + this.adBreakStartAdjustment;
                }
                if (rawAdBreak.durationInSeconds) {
                    adBreak.expectedDuration = Math.max(rawAdBreak.durationInSeconds - (adBreakType === AdBreakType.Preroll ? 0 : this.adBreakEndAdjustment), 0);
                }
                return adBreak;
            }
        },
        {
            key: "adaptAd",
            value: function adaptAd(adBreak, rawAdBreak, rawAd, idx, isCsai, adServerCdn) {
                var adaptedAd = isCsai ? this.parseAdData(rawAd, adBreak, 'VodAd', adServerCdn) : this.parseAdData(rawAd, adBreak, 'Ad', adServerCdn);
                if (adaptedAd.companions) {
                    var isBrightlineAd = adaptedAd.companions.some(function(cmp) {
                        return cmp.provider === CompanionProvider.Brightline;
                    });
                    if (isBrightlineAd) {
                        adBreak.features = _object_spread_props(_object_spread({}, adBreak.features), {
                            containsBrightlineAds: true
                        });
                        adaptedAd.features = _object_spread_props(_object_spread({}, adaptedAd.features), {
                            isBrightlineAd: true
                        });
                    }
                }
                adaptedAd.advertisingContentType = getAdvertisingContentType(adaptedAd.extensions || []);
                var isLastAdInBreak = false;
                if (rawAdBreak.duration) {
                    // With paginated ad data coming in, not all ads will be in the same ad call - e.g. in a 4-ad break, the last MT tracking call will contain only ad 3 and ad 4
                    isLastAdInBreak = roughlyEquals(rawAdBreak.startTimeInSeconds + rawAdBreak.durationInSeconds, rawAd.startTimeInSeconds + rawAd.durationInSeconds, 0.75);
                } else // must be larger than this.adBreakEndAdjustment
                {
                    isLastAdInBreak = idx === rawAdBreak.nonLinearAdsList.length - 1;
                }
                if (isLastAdInBreak) {
                    adaptedAd.expectedDuration = adaptedAd.expectedDuration - this.adBreakEndAdjustment;
                }
                return adaptedAd;
            }
        },
        {
            key: "parseAdBreakData",
            value: function parseAdBreakData(rawAdBreak, isCsai, adServerCdn) {
                var _this = this;
                var adBreak = this.initialiseAdBreak(rawAdBreak);
                var adBreakTrackingEvents = this.getAdBreakTrackingEvents(rawAdBreak);
                rawAdBreak.ads.forEach(function(rawAd, idx) {
                    rawAd.trackingEvents = _this.populateAdTrackingEventsAndAdBreakTrackingEvents(rawAd, adBreakTrackingEvents);
                    var adaptedAd = _this.adaptAd(adBreak, rawAdBreak, rawAd, idx, isCsai, adServerCdn);
                    adBreak.ads.push(adaptedAd);
                });
                if (!adBreak.expectedDuration) {
                    // If there is still no expectedDuration then we will infer it based on duration of individual ads
                    // TODO: Fix this for pagination?
                    adBreak.expectedDuration = adBreak.ads.reduce(function(acc, ad) {
                        return acc += ad.expectedDuration;
                    }, 0);
                }
                adBreak.trackingEvents = this.dedupeTrackingEvents(adBreakTrackingEvents);
                return adBreak;
            }
        },
        {
            key: "dedupeTrackingEvents",
            value: function dedupeTrackingEvents(trackingEventsArray) {
                var seenEventUrls = new Set();
                return trackingEventsArray.filter(function(trackingEvent) {
                    return seenEventUrls.has(trackingEvent.url) ? false : seenEventUrls.add(trackingEvent.url);
                });
            }
        },
        {
            key: "populateAdTrackingEventsAndAdBreakTrackingEvents",
            value: function populateAdTrackingEventsAndAdBreakTrackingEvents(rawAd, adBreakTrackingEvents) {
                var _this = this;
                var rawAdBreakEvents = rawAd.trackingEvents.filter(function(event) {
                    return [
                        TrackingEventType.BreakStart,
                        TrackingEventType.BreakEnd
                    ].includes(event.eventType);
                });
                rawAdBreakEvents === null || rawAdBreakEvents === void 0 ? void 0 : rawAdBreakEvents.forEach(function(event) {
                    var _adBreakTrackingEvents;
                    (_adBreakTrackingEvents = adBreakTrackingEvents).push.apply(_adBreakTrackingEvents, _to_consumable_array(_this.parseTrackingEvent(event)));
                });
                return rawAd.trackingEvents.filter(function(event) {
                    return !rawAdBreakEvents.includes(event);
                });
            }
        },
        {
            key: "determineAdStreamProtocol",
            value: function determineAdStreamProtocol() {
                return isSafariDesktop(CoreVideoInternal.deviceInfo, CoreVideoInternal.deviceType) ? StreamingProtocol.HLS : StreamingProtocol.DASH;
            }
        },
        {
            key: "determineNonLinearAdType",
            value: function determineNonLinearAdType(nonLinearAdMetExtensionsContent) {
                var nonLinearAdType = null;
                if (!nonLinearAdMetExtensionsContent) return nonLinearAdType;
                nonLinearAdMetExtensionsContent.forEach(function(param) {
                    var content = param.content;
                    if (!content) return;
                    if (content.includes('framead')) return nonLinearAdType = 'Frame';
                    if (content.includes('marqueead')) return nonLinearAdType = 'Marquee';
                });
                return nonLinearAdType;
            }
        },
        {
            key: "parseNonLinearAdDataExtensions",
            value: function parseNonLinearAdDataExtensions(extensionsContent, adCreativeId) {
                var regexpPattern = '(?:<CreativeParameter creativeId="' + adCreativeId + '" name="Conviva Ad Insights" type="(?:.+)"><!\\[CDATA\\[)({.+})(?:\\]\\]><\\/CreativeParameter>)';
                var adInsights = extensionsContent.match(new RegExp(regexpPattern));
                return adInsights ? JSON.parse(decodeURIComponent(adInsights[1])) : {};
            }
        },
        {
            key: "getAdVerifications",
            value: /**
     * Ad Verifications may be included as a top level property in the AdMetadata object or
     * as XML in the extensions. We should default to using the top level property if it
     * exists and fall back to parsing the extensions.
     *
     * See VAST guidelines: https://www.iab.com/wp-content/uploads/2016/04/VAST4.0_Updated_April_2016.pdf#page=61
     *
     * An example of the AdVerifications node in extensions is:
     *
     * "<AdVerifications>
     *    <Verification vendor="moat.com-gfddsfgfds234523523">
     *        <JavaScriptResource apiFramework="omid" browserOptional="true">
     *            <![CDATA[ https://z.moatads.com/sdgdsgdfsgds/moatvideo.js ]]>
     *        </JavaScriptResource>
     *        <TrackingEvents/>
     *        <VerificationParameters>
     *            <![CDATA[ {"zMoatTPC":"preroll"} ]]>
     *        </VerificationParameters>
     *    </Verification>
     * </AdVerifications>"
     *
     * Which we should parse into an AdVerifications object:
     *
     * {
     *      vendor: 'moat.com-gfddsfgfds234523523',
     *      javaScriptResource: {
     *          apiFramework: 'omid',
     *          browserOptional: 'true',
     *          uri: 'https://z.moatads.com/sdgdsgdfsgds/moatvideo.js',
     *      },
     *      verificationParameters: '{"zMoatTPC":"preroll"}',
     *      executableResource: [],
     *      trackingEvents: [],
     * }
     *
     * @param ad
     * @returns JsonAdVerificationsMetadata[]
     */ function getAdVerifications(ad) {
                if (ad.adVerifications && ad.adVerifications.length > 0) {
                    return ad.adVerifications;
                }
                try {
                    var adVerificationsContext = ad.extensions.find(function(extension) {
                        return extension.type === 'AdVerifications';
                    });
                    if (adVerificationsContext === undefined) {
                        return [];
                    }
                    var verifications = parseTxmlContent(adVerificationsContext.content)[0].children;
                    return verifications.map(function(verificationNode) {
                        var javaScriptResourceNode = findNodeWithTagName(verificationNode, 'JavaScriptResource');
                        var verificationParametersNode = findNodeWithTagName(verificationNode, 'VerificationParameters');
                        var vendorString = getAttributeFromNode(verificationNode, 'vendor');
                        return {
                            vendor: vendorString,
                            javaScriptResource: javaScriptResourceNode === undefined ? [] : [
                                {
                                    apiFramework: getAttributeFromNode(javaScriptResourceNode, 'apiFramework'),
                                    browserOptional: getAttributeFromNode(javaScriptResourceNode, 'browserOptional'),
                                    uri: javaScriptResourceNode.children[0]
                                }
                            ],
                            verificationParameters: verificationParametersNode === null || verificationParametersNode === void 0 ? void 0 : verificationParametersNode.children[0],
                            executableResource: [],
                            trackingEvents: []
                        };
                    });
                } catch (e) {
                    sdkLogger.withContext('JsonAdBreaksAdapter').error('Failed to parse Ad Verifications', e);
                    return [];
                }
            }
        }
    ]);
    return JsonAdBreaksAdapter;
}();

//# sourceMappingURL=json-ad-breaks-adapter.js.map